<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <VehicleBrandForm v-if="vehicleBrand" :vehicleBrand="vehicleBrand" />
      <LoadingPage v-if="!vehicleBrand"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import VehicleBrandForm from '@/components/settings/test-registers/vehicleBrands/VehicleBrandsForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'VehicleBrandEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    VehicleBrandForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      vehicleBrand: state => state.vehiclebrands.vehicleBrandById
    })
  },
  methods: {
    ...mapActions('vehiclebrands', ['fetchById'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  }
}
</script>
